// removed by extract-text-webpack-plugin
module.exports = {"QASection":"QASection","qaSection":"QASection","QASection__content":"QASection__content","qaSectionContent":"QASection__content","QASection__content__heading":"QASection__content__heading","qaSectionContentHeading":"QASection__content__heading","QASection__icon":"QASection__icon","qaSectionIcon":"QASection__icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/QASection.scss
// module id = 505
// module chunks = 0